import { render, staticRenderFns } from "./context-menu.vue?vue&type=template&id=bfed8652&scoped=true&"
import script from "./context-menu.vue?vue&type=script&lang=js&"
export * from "./context-menu.vue?vue&type=script&lang=js&"
import style0 from "./context-menu.vue?vue&type=style&index=0&id=bfed8652&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfed8652",
  null
  
)

export default component.exports